// @ts-nocheck
import React from 'react'
import PropTypes from 'prop-types'
import { colors } from '@lmc/common/constants'

// Keeps a small gap in the ring if progress < 100
const calculateProgress = (progress) => {
  if (progress > 95 && progress < 100) return 95

  return progress
}

const ProgressRing = ({
  color = colors.blue,
  progress = 0,
  radius = 40,
  showText = true,
  style,
}) => (
  <svg height={radius} width={radius} viewBox="0 0 36 36" style={style}>
    <path
      d="M18 2.0845
            a 15.9155 15.9155 0 0 1 0 31.831
            a 15.9155 15.9155 0 0 1 0 -31.831"
      style={styles.backgroundCircle}
    />
    <path
      fill="none"
      stroke={color}
      strokeDasharray={`${calculateProgress(progress)}, 100`}
      d="M18 2.0845
            a 15.9155 15.9155 0 0 1 0 31.831
            a 15.9155 15.9155 0 0 1 0 -31.831"
      style={styles.circle}
    />
    {showText && (
      <text x="18" y="21" style={styles.text}>
        {progress}%
      </text>
    )}
  </svg>
)

const styles = {
  backgroundCircle: {
    fill: 'none',
    stroke: colors.lightgrey,
    strokeWidth: 4,
  },
  circle: {
    strokeWidth: 4,
    strokeLinecap: 'round',
    animation: 'progress 1s ease-out forwards',
  },
  text: {
    fill: colors.black,
    fontSize: 9,
    textAnchor: 'middle',
  },
}

ProgressRing.propTypes = {
  color: PropTypes.string,
  progress: PropTypes.number,
  radius: PropTypes.number,
  showText: PropTypes.bool,
  style: PropTypes.object,
}

export default ProgressRing
